import { Link } from "@inertiajs/react";
import type { ReactNode } from "react";

export function ActivationGuide({
  id,
  title,
  children,
  links,
}: {
  id?: string;
  title: string;
  children: ReactNode;
  links: { href: string; label: string; detail: string }[];
}) {
  return (
    <section id={id} className="py-12 sm:py-16">
      <h2 className="max-w-3xl text-3xl font-bold text-gray-900 dark:text-white">{title}</h2>
      <div className="mt-4 max-w-3xl space-y-4 text-base leading-7 text-gray-600 dark:text-gray-300">{children}</div>
      <ul className="mt-8 grid gap-4 md:grid-cols-2">
        {links.map((link) => (
          <li
            key={link.href}
            className="rounded-2xl border border-orange-200/80 bg-white/90 p-5 dark:border-orange-500/30 dark:bg-gray-900/80"
          >
            <Link
              href={link.href}
              className="text-base font-semibold text-orange-700 hover:underline dark:text-orange-300"
            >
              {link.label}
            </Link>
            <p className="mt-2 text-sm leading-6 text-gray-600 dark:text-gray-300">{link.detail}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
